module.exports = __webpack_public_path__ + "img/foto 14.675bc4da.jpg";